<template lang="html">
  <div>
    <v-row
      class="mb-4" 
      align="center" 
    >
      <h6 class="pl-3 title font-weight-medium">
        {{ text.header }}
      </h6>
    </v-row>
    <div v-if="!summary">
      <p>
        {{ text.description }}
      </p>

      <ul>
        <li 
          v-for="(effect,index) in text.effects" 
          :key="index"
        >
          {{ effect }}
        </li>
      </ul>

      <v-form 
        ref="form"
      >
        <v-container>
          <v-row>
            <v-col 
              cols="12" 
              md="12"
            >
              <v-autocomplete
                v-if="!form.reportToVessel"
                v-model="form.userInChargeId"
                v-validate="'required'"
                :items="filteredUsers"
                :error-messages="errors.collect('om_uid')"
                class="autocomplete-zindex"
                data-vv-name="om_uid"
                data-vv-as="BIC"
                item-text="name"
                item-value="user_uid"
                label="Branch Incharge (BIC)"
              />
            </v-col>

            <v-col 
              cols="12" 
            >
              <v-checkbox
                v-model="form.reportToVessel"
                class="mt-0 pt-0"
                label="Temporary no BIC"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <div v-else>
      <p>
        {{ actionSummary.description }}
      </p>

      <ul>
        <li 
          v-for="(effect,index) in actionSummary.effects" 
          :key="index"
        >
          <span class="font-weight-medium">{{ effect }}</span>
        </li>
      </ul>
    </div>
      
    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="!summary"
        :loading="progressing"
        class="mx-2 font-weight-light"
        color="success"          
        @click="showSummary"
      >
        Save
      </v-btn>

      <v-btn
        v-if="summary"
        :disabled="progressing"
        text
        @click="summary = false"
      >
        Cancel
      </v-btn>

      <v-btn
        v-if="summary"
        :loading="progressing"
        class="mx-2 font-weight-light"
        color="success"          
        @click="submitForm"
      >
        Confirm Changes
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    $_veeValidate: {
      validator: 'new', // give me my own validator scope.
    },
    props: {
      users: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data () {
      return {
        text: {
          header: 'Internal CRO to BIC (Promotion)',
          description: 'This form is for promoting a CRO to a BIC within the same branch. What this form will do is as follows:',
          effects: [
            'Selected CRO will be set as branch\'s new BIC',
            'Remaining CRO will report to new BIC',
          ],
        },
        progressing: false,
        form: {
          userInChargeId: '',
          reportToVessel: false,
        },
        summary: false,
      }
    },
    computed: {
      filteredUsers () {
        return this.users.filter((user) => {
          return user.vessel === null
        })
      },   
      actionSummary () {
        if (this.form.reportToVessel === true) {
          return {
            description: 'This form is for promoting a CRO to a BIC within the same branch. Confirm your actions:',
            effects: [
              'Remaining CRO of ' + this.branch.branch_name + ' will report to vessel', 
            ],
          }
        }

        return {
          description: 'This form is for promoting a CRO to a BIC within the same branch. Confirm your actions:',
          effects: [
            this.newBic.name + ' will be set as ' + this.branch.branch_name + '\'s new BIC',
            'Remaining CRO of ' + this.branch.branch_name + ' will report to ' + this.newBic.name,
          ],
        }
      },
      bic () {
        return this.users.find((user) => {
          return user.user_uid === this.branch.branch_person_in_charge_uid
        })
      },
      newBic () {
        return this.users.find((user) => {
          return user.user_uid === this.form.userInChargeId
        })
      },
      ...mapGetters({
        branch: 'branch/currentBranch',
      }),
    },
    watch: {
    
    },
    mounted () {
   
    },
    methods: {
      showSummary () {
        this.validateForm().then((result) => {
          if (result) {          
            this.summary = true
          } else {
            this.$scrollToFirstErrorInput()
          }
        })  
      },

      prepareFormData () {
        let form = this.form

        return {
          branch_person_in_charge_uid: this.form.reportToVessel === true ? this.branch.vessel_uid : form.userInChargeId,
        }
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      clearForm () {
        this.summary = false
        this.form.userInChargeId = ''
        this.form.reportToVessel = false
      },
      emitCloseDialogEvent () {
        this.$emit('close-dialog')
      },

      submitForm () {
        this.validateForm().then((result) => {        
          if (result) {          
            this.setProgressing(true)

            this.$api.branches().internalPromotion(this.branch.branch_uid, this.prepareFormData())
              .then((res) => {
                if (res.status >= 200 && res.status < 300) {
                  this.$snack({
                    message: 'BIC updated',
                  })
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
                this.emitCloseDialogEvent()
                this.clearForm()
              })
          } else {
            this.$scrollToFirstErrorInput()
          }
        })  
      },
      validateForm () {
        return this.$validator.validateAll()
      },
    
    },
  }
</script>

<style lang='css' scoped>  
  .autocomplete-zindex{
    z-index:250
  }
</style>
